import { render } from "./UiTestForm.vue?vue&type=template&id=426daa1d"
import script from "./UiTestForm.vue?vue&type=script&lang=js"
export * from "./UiTestForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__